import { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import {
    useIsAuthenticated,
    MsalAuthenticationTemplate,
} from "@azure/msal-react";
import {
    AppInsightsContext,
    withAITracking,
} from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./AppInsights";
import { InteractionType } from "@azure/msal-browser";
import { Spin } from "antd";
import { PageLayout } from "./components/PageLayout";
import Model from "./pages/Model";
import { Role } from "./pages/Role";
import Builder from "./pages/Builder";
import Poi from "./pages/POI";
import Mapper from "./pages/Mapper";
import PoiMapping from "./pages/PoiMapping";
import { LoginRedirect } from "./components/Login";
import "./App.css";
import { Checking } from "./pages/Checking";
import useTrackPageView from "./useTrackPageView";

import { ThemeProvider } from './components/ThemeContext.js';
import ThemeWrapper from "./components/ThemeWrapper.jsx";

/**
 * The root app component of the application
 */
function App() {
    const [isRole, setIsRole] = useState(false);
    const isCheck = localStorage.getItem("checkRole");
    const isAuthenticated = useIsAuthenticated();

    /**
     * Function to set role
     * @param {*} check  boolean value
     */
    const checkRole = (check) => {
        setIsRole(check);
        localStorage.removeItem("TwinBuilder3DTheme");
    };
    /* Disable Tab key interaction*/
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    /**
     * React hook to handle side effect
     */
    useEffect(() => {
        if (isCheck) {
            setIsRole(isCheck);
        }
        // eslint-disable-next-line
    }, []);
    // Use custom hook to track page views
    useTrackPageView();

    return (
        <ThemeProvider>
            <ThemeWrapper>
                <AppInsightsContext.Provider value={reactPlugin}>
                    <PageLayout role={isRole}>
                        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                            <Routes>
                                <Route path="model" element={<Model role={isRole} />} />
                                <Route path="adminError" element={<Role />} />
                                <Route path="plant" element={<Builder />} />
                                <Route path="poi" element={<Poi />} />
                                <Route path="mapper" element={<Mapper />} />
                                <Route path="assetmapper" element={<PoiMapping />} />
                                <Route path="/" element={<Checking role={isRole} />} />
                            </Routes>
                        </MsalAuthenticationTemplate>
                        {!isAuthenticated && (
                            <>
                                <LoginRedirect checkRole={checkRole} />
                                <div className="centerPage">
                                    <Spin>
                                        <p>Please wait signing you in</p>{" "}
                                    </Spin>
                                </div>
                            </>
                        )}
                    </PageLayout>
                </AppInsightsContext.Provider>
            </ThemeWrapper>
        </ThemeProvider>
    );
}
const TrackedApp = withAITracking(reactPlugin, App);
export default TrackedApp;
